import {
  AppBar,
  Box,
  Button,
  InputAdornment,
  Stack,
  styled,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import logo from "../assets/motalvip-icon.svg"
import coverImage from "../assets/cover-image.jpg"
import { useQueryState } from "nuqs"
import SearchIcon from '@mui/icons-material/Search'
import { usePublicClaimDetailQuery } from "../client/query-client/useClaimQuery";
import { useState } from "react";
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import { ClaimDetailCard } from "../component/claim/ClaimDetailCard";
import { ClaimStatusHistoryCard } from "../component/claim/ClaimStatusHistoryCard";
import { Spin } from "../component/common/Spin";

const Form = styled('form')`
  .MuiFormControl-root {
    border-radius: 4px;
  }
`

export const HomeScreen = () => {
  const [claimNo, setClaimNo] = useQueryState("claimNo", {
    defaultValue: "",
  })
  const [claimNoInput, setClaimNoInput] = useState(claimNo || '')

  const { data: claimDetail, refetch: refetchClaimDetail, isLoading } = usePublicClaimDetailQuery({
    claimNo: claimNo,
  }, !!claimNo)

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setClaimNoInput(event.target.value);
  }

  const handleSearchSubmit = async (event: React.FormEvent) => {
    event.preventDefault()
    await setClaimNo(claimNoInput)
    refetchClaimDetail()
  }

  return (
    <Box pb="24px">
      <AppBar position="fixed" color="primary">
        <Toolbar sx={{ padding: "4px 16px" }}>
          <Stack direction="row" spacing={{ xs: "16px", md: "42px" }} alignItems="center">
            <img src={logo} alt="logo" width="50px" />
            <Typography fontSize={{ xs: "16px", md: "22px" }} fontWeight={500} color="#FFFFFF">ติดตามสถานะการซ่อมสินค้า</Typography>
          </Stack>
        </Toolbar>
      </AppBar>
      <Box sx={{
        backgroundImage: `url(${coverImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        width: "100vw",
        height: { xs: "150px", md: "286px" },
        marginTop: { xs: "62px", md: "70px" },
      }}>
        <div style={{
          padding: '0 20px',
          display: "flex",
          justifyContent: "center",
          alignItems: "end",
          height: "100%",
        }}>
          <Form
            sx={{
              display: "flex",
              width: { xs: "100%", md: "700px" },
              marginBottom: "-28px",
            }}
            onSubmit={handleSearchSubmit}
          >
            <TextField
              sx={{
                margin: 0,
                padding: 0,
                backgroundColor: "#FFF",
                width: "100%",
              }}
              placeholder="กรอกเลขที่สัญญา"
              value={claimNoInput || ''}
              onChange={handleSearchChange}
              variant="outlined"
              fullWidth
              margin="normal"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <Button type="submit" variant="contained" color="primary">
                      ติดตามสินค้า
                    </Button>
                  </InputAdornment>
                ),
              }}
            />
          </Form>
        </div>
      </Box>
      <Spin spinning={isLoading}>
        {claimDetail ? (
          <Box sx={{ marginTop: { xs: "46px", md: "76px" }, padding: { xs: "0 20px", md: "0 32px" } }}>
            <Stack direction={{ xs: "column", md: "row" }} gap={{ xs: "20px", md: "24px" }}>
              <ClaimDetailCard claimDetail={claimDetail} />
              <ClaimStatusHistoryCard claimDetail={claimDetail} />
            </Stack>
          </Box>
        ) : (
          <Box sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            marginTop: "120px",
          }}>
            <ArticleOutlinedIcon sx={{ color: "#334046", width: "36px", height: "36px" }} />
            <Typography fontSize="16px" fontWeight={400} color="#6F6F6F" marginTop="10px">{claimNo ? "ไม่พบเลขที่สัญญา กรุณาลองใหม่อีกครั้ง" : "กรอกเลขที่สัญญาเพื่อดูสถานะการซ่อม"}</Typography>
          </Box>
        )}
      </Spin>
    </Box>
  );
};
